<div class="row">
  <div class="col-12">
    <div *ngIf="selectedAttachment" class="mb-4">
      <ng-container [ngTemplateOutlet]="selectedAttachment ? preview : null"></ng-container>
    </div>
    <ng-container *ngTemplateOutlet="selectTemplate()"></ng-container>
  </div>
</div>

<ng-template #preview>
  <ng-container [ngSwitch]="_selectedAttachment.displayType">
    <div style="height: 300px">
      <sb-comp-medium *ngSwitchCase="'EMBED'" [customHeight]="'300px'" [customWidth]="'100%'"
                      [medium]="medium" [showFullOnClick]="true" [title]="true" style="width: 100%"></sb-comp-medium>
      <iframe *ngSwitchCase="'IFRAME'" [src]="url | safeElement : 'url'" [title]="selectedAttachment.description"
              height="300px"
              width="100%"></iframe>
    </div>
    <div *ngSwitchCase="'IFRAME'" class="text-muted font-weight-bold">{{'lang.globals.iframeWarning'|translate}}</div>
    <div *ngSwitchCase="'IFRAME'">
      <span *ngIf="url.substring(0, 8) !== 'https://'"
            class="red font-weight-bold">{{'lang.globals.notSafeUrl'|translate}}</span>
    </div>
  </ng-container>
</ng-template>

<ng-template #optionsTmp>
  <div sb-comp-attachment-upload class="d-flex justify-content-between flex-column" style="height: 400px;"></div>
</ng-template>

<ng-template #linkTmp>
  <app-attachment-url [attachment]="selectedAttachment"></app-attachment-url>
  <ng-container [ngTemplateOutlet]="selectedAttachment ? attachmentSettings : null"></ng-container>
</ng-template>

<ng-template #uploadTmp>
  <app-attachment-file [attachment]="selectedAttachment"></app-attachment-file>
  <ng-container [ngTemplateOutlet]="selectedAttachment ? attachmentSettings : null"></ng-container>
</ng-template>

<ng-template #attachmentSettings>
  <div class="row mt-3">
    <div class="col-6">
      <button (click)="openModal.attachmentLinkAttachmentToEntries(selectedAttachment)"
              class="btn btn-primary w-100">
        <sb-icon icon="attachmentLink"></sb-icon>&nbsp;{{'lang.globals.linkAttachment' | translate}}
      </button>
    </div>
    <div class="col-6">
      <button (click)="deleteAttachment()" class="btn btn-danger w-100">
        <sb-icon icon="trash"></sb-icon>&nbsp;{{'lang.globals.deleteFile' | translate}}
      </button>
    </div>
  </div>
</ng-template>
